import styled from 'styled-components'
import { colors } from 'utils'

export const TopHeader = styled.h1`
    margin: 0;
    font-size: 30px;
    font-weight: bold;
    line-height: 35px;
    color: ${colors.dark};
    opacity: 0.9;
`

export const CardHeader = styled.h3`
    width: 100%;
    margin: 0;
    font-size: 20px;
    line-height: 23px;
    font-weight: bold;
    color: ${colors.grayTitle};
    opacity: 0.9;
`
